
import { SimplePagination } from "@/components/ui/shared/SimplePagination";

interface BillsPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function BillsPagination({ currentPage, totalPages, onPageChange }: BillsPaginationProps) {
  return (
    <SimplePagination
      page={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
